
import { Filter } from "lucide-react";
import { ComponentType } from "@/utils/types/componentTypes";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";

interface ComponentsFilterProps {
  componentTypes: ComponentType[];
  typeFilter: string | null;
  onTypeFilterChange: (value: string | null) => void;
  onFilterChange: (value: string) => void;
}

export function ComponentsFilter({ 
  componentTypes,
  typeFilter,
  onTypeFilterChange,
  onFilterChange
}: ComponentsFilterProps) {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center gap-4 bg-muted/50 p-4 rounded-lg">
      <div className="flex items-center w-full md:w-auto">
        <Filter className="h-4 w-4 text-primary mr-2" />
        <span className="text-sm font-medium text-foreground">Filtrar por nome:</span>
      </div>
      <div className="w-full md:w-64">
        <Input 
          placeholder="Buscar componente..." 
          className="border-primary/20 focus:border-primary"
          onChange={(e) => onFilterChange(e.target.value)} 
        />
      </div>
      
      <div className="flex items-center w-full md:w-auto mt-2 md:mt-0">
        <Filter className="h-4 w-4 text-primary mr-2" />
        <span className="text-sm font-medium text-foreground">Filtrar por tipo:</span>
      </div>
      <div className="w-full md:w-64">
        <Select 
          value={typeFilter || ""} 
          onValueChange={(value) => onTypeFilterChange(value === "all" ? null : value)}
        >
          <SelectTrigger className="bg-card border-primary/20 focus:border-primary">
            <SelectValue placeholder="Selecione um tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os tipos</SelectItem>
            {componentTypes.map((type) => (
              <SelectItem key={type.id} value={type.id}>
                {type.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
